import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './Navbar.css';
import { useContent } from '../../contexts/ContentContext';

const Navbar: React.FC = () => {
  const { language, toggleLanguage } = useLanguage();
  const [activeSection, setActiveSection] = React.useState('home');
  const { content, isLoading } = useContent();

  React.useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'home';
      setActiveSection(hash);
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  if (isLoading || !content) return null;

  const labels = content.navbar[language];

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="logo">
          <a href="#home">{labels.brand}</a>
        </div>
        <div className="nav-right">
          <ul className="nav-links">
            {labels.links.map(link => (
              <li key={link.id}><a href={`#${link.id}`} className={activeSection === link.id ? 'active' : ''}>{link.label}</a></li>
            ))}
          </ul>
          <div className="language-switch">
            <div className={`lang-slider ${language === 'jp' ? 'jp' : ''}`}></div>
            <button
              onClick={toggleLanguage}
              className={`language-button ${language === 'en' ? 'active' : ''}`}
            >
              EN
            </button>
            <button
              onClick={toggleLanguage}
              className={`language-button ${language === 'jp' ? 'active' : ''}`}
            >
              JP
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 